export class Collection<T> {
  constructor(
        readonly items: Array<T>,
        readonly count: number,
        readonly totalCount: number
  ) {}
}